import { useTranslation } from 'react-i18next';

import { Icon } from '~/chords/Icon';
import { cn } from '~/chords/lib/cn';

interface DropdownTriggerClearButtonProps {
  onClear?: () => void;
  className?: string;
}

export function DropdownTriggerClearButton({
  onClear,
  className,
}: DropdownTriggerClearButtonProps) {
  const { t } = useTranslation('common');

  return (
    <button
      type="button"
      aria-label={t('dropdownTree.clearSelection')}
      onClick={() => onClear?.()}
      className={cn(
        // Visibility: faded out until the trigger group is hovered or the
        // button itself receives keyboard focus. Uses the named
        // `group/dropdown-trigger` set on DropdownTrigger's wrapper so an
        // unrelated ancestor `.group` (e.g. a `<details class="group">`) can't
        // accidentally reveal the button when the pointer hovers anywhere
        // inside that ancestor.
        'pointer-events-none opacity-none transition-[opacity,background-color] duration-200',
        'group-hover/dropdown-trigger:pointer-events-auto group-hover/dropdown-trigger:opacity-full',
        'focus-visible:pointer-events-auto focus-visible:opacity-full',

        // Match IconButton size="small" chrome (round hover background centered
        // on the X) without nesting an interactive element inside the button.
        'flex size-[1.75rem] items-center justify-center rounded-full p-xs',
        'text-default hover:bg-emphasis-strong',
        className,
      )}
    >
      <Icon size="sm" type="xmark" aria-hidden />
    </button>
  );
}

DropdownTriggerClearButton.displayName = 'DropdownTriggerClearButton';
